var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{class:("phone-form-item_" + (_vm.item.id)),style:(_vm.style),attrs:{"id":_vm.options.id,"name":_vm.options.name,"placeholder":_vm.options.placeholder}})}
var staticRenderFns = []

export { render, staticRenderFns }